const CarChangeDisplayAmts =[
    {type: "CarMonthlyAmts", textLineArr: [
        {textLine: "Current Monthly Income", plusMinus: "", amount: "VARmonthlyIncome", skipIfZero: false},
        {textLine: "Total Trade-In Amt For Current Car", plusMinus: "", amount: "VARtradeInAmt", skipIfZero: true},
        {textLine: "Current Loan Balance", plusMinus: "+", amount: "VARtotalCurrentCarLoanAmt", skipIfZero: true},
        {textLine: "Trade-In Value Applied to Current Loan", plusMinus: "-", amount: "VARcurrentLoanTradeInAmt", skipIfZero: false,
            classCond: true},
        {textLine: "Cost of the Car Selected", plusMinus: "", amount: "VARcarCost", skipIfZero: false},
        {textLine: "Trade-In Value Applied to New Loan", plusMinus: "-", amount: "VARnewLoanTradeInAmt", 
            skipIfZero: true, classCond: true},
        {textLine: "Cash Amount Down", plusMinus: "-", amount: "VARdownPaymentAmt", skipIfZro: true,
            classCond: true},
        {textLine: "Total Amount Of New Loan", plusMinus: "=", amount: "VARloanAmt", skipIfZero: false},
        ]
    },
    {type: "CarCashAmts", textLineArr: [
        {textLine: "Current Cash Amt", plusMinus: "", amount: "VARcurrentCash", skipIfZero: false},
        {textLine: "Loan Processing Fee", plusMinus: "-", amount: "VARloanProcessAmt", 
            skipIfZero: true, classCond: true},
        {textLine: "Cash Amount Down", plusMinus: "-", amount: "VARdownPaymentAmt", skipIfZero: false,
            varClass: "text-danger", classCond: true},
        {textLine: "Bicycle & Walking Shoes", plusMinus: "-", amount: "VARnoCarAmt", skipIfZero: true,
            varClass: "text-danger", classCond: true },
        {textLine: "Good Walking Shoes", plusMinus: "-", amount: "VARnoBikeAmt", skipIfZero: true,
            varClass: "text-danger", classCond: true },
        {textLine: "Trade-In Amount Added to Cash", plusMinus: "+", amount: "VARtradeInProfit", skipIfZero: true,
            },
          {textLine: "Current Car Trade-In Amt", plusMinus: "-", amount: "VARrefundAmt", skipIfZero: true,
            varClass: "text-danger", classCond: true},
        {textLine: "Trade-In Applied to Loan", plusMinus: "-", amount: "VARappliedToLoan", skipIfZero: true,
            varClass: "text-danger", classCond: true },
      
        {textLine: "Total Change to Cash", plusMinus: "=", amount: "VARchangeCashAmt", skipIfZero: false},
        ]

    }
]
export default CarChangeDisplayAmts;